const ArrowDown = () => {
  return (
    <svg
      width="19"
      height="9.5"
      viewBox="0 0 21 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon MuiSelect-iconOutlined css-hfutr22-MuiSvgIcon-root-MuiSelect-icon"
    >
      <path d="M1 1L10.5 10.5L20 1" stroke="#999999" strokeWidth="2" />
    </svg>
  )
}

export default ArrowDown
